<template>
<div class="chapter">
<div class="inner_page">
<p class="txc1" id="pz9-1"><i>Forgiveness is nothing less than the way we heal the world.</i></p>
<p class="txc" id="pz9-2">—B<span class="small">ISHOP</span> D<span class="small">ESMOND</span> T<span class="small">UTU AND</span> M<span class="small">PHO </span></p>
<p class="txc" id="pz9-3">T<span class="small">UTU</span>, <i>T<span class="small">HE</span> B<span class="small">OOK OF</span> F<span class="small">ORGIVING</span></i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?3859b540